import { render, staticRenderFns } from "./view.vue?vue&type=template&id=5a1918b2&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=5a1918b2&prod&lang=scss&scoped=true&"
import style1 from "./view.vue?vue&type=style&index=1&id=5a1918b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1918b2",
  null
  
)

export default component.exports